// src/app/modules/Auth/_redux/authCrud.js
import axios from "axios";
import config from "../../../../config";

export const URL = config.URL;

// ================================
// AUTHENTICATION
// ================================

export function register(data) {
  return axios.post(`${URL}auth/register`, data);
}

export function login(data) {
  return axios.post(`${URL}auth/login`, data);
}

export function logout(refreshToken) {
  return axios.post(`${URL}auth/logout`, { refreshToken });
}

export function switchOrganization(organizationId) {
  return axios.post(`${URL}onboarding/switch-organization/${organizationId}`);
}

export function refreshToken(refreshToken) {
  return axios.post(`${URL}auth/refresh-tokens`, { refreshToken });
}

export function forgotPassword(data) {
  return axios.post(`${URL}auth/forgot-password`, data);
}

export function resetPassword(data) {
  return axios.post(`${URL}auth/reset-password?token=${data.token}`, {
    password: data.password,
  });
}

export function sendVerificationEmail() {
  return axios.post(`${URL}auth/send-verification-email`);
}

export function getInviteByToken(token) {
  return axios.get(`${URL}invitations/${token}`);
}

export function acceptInvite(token, data) {
  return axios.post(`${URL}invitations/${token}/accept`, data);
}

export function reset_password(body) {
  return axios.post(`${URL}auth/reset-password`, body);
}

export function verifyEmail(body) {
  return axios.post(`${URL}auth/verify-email`, body);
}

// ================================
// USER PROFILE
// ================================

export function getUserByToken() {
  return axios.get(`${URL}user/profile`);
}

export function updateUserProfile(data) {
  return axios.put(`${URL}user/profile`, data);
}

export function changePassword(data) {
  return axios.put(`${URL}user/change-password`, data);
}

// ================================
// ORGANIZATIONS
// ================================

/**
 * Get all organizations the current user belongs to (as admin).
 */
export function getUserOrganizations() {
  return axios.get(`${URL}onboarding/my-organizations?type=admin`);
}

/**
 * Create a new organization (triggers auto-trial on the backend).
 */
export function createOrganization(data) {
  return axios.post(`${URL}onboarding/organization`, data);
}

/**
 * Update organization general info (name, email, phone, description, website).
 * Address/location changes use the location endpoints below.
 */
export function updateOrganization(organizationId, data) {
  return axios.patch(`${URL}organizations/${organizationId}`, data);
}



// ================================
// LOCATIONS
// ================================

/**
 * Get all locations for an organization.
 * Returns { address, locations[] } — always backward compatible.
 */
export function getOrganizationLocations(organizationId) {
  return axios.get(`${URL}organizations/${organizationId}/locations`);
}

/**
 * Add a new location (branch/gate/site) to an organization.
 * Body: { name, address: { street, city, state, coordinates? }, is_primary?, phone?, email?, notes? }
 */
export function addOrganizationLocation(organizationId, data) {
  return axios.post(`${URL}organizations/${organizationId}/locations`, data);
}

/**
 * Update a location (partial — only send changed fields).
 */
export function updateOrganizationLocation(organizationId, locationId, data) {
  return axios.patch(
    `${URL}organizations/${organizationId}/locations/${locationId}`,
    data
  );
}

/**
 * Remove a location.
 * Cannot remove the primary location while others exist.
 */
export function removeOrganizationLocation(organizationId, locationId) {
  return axios.delete(
    `${URL}organizations/${organizationId}/locations/${locationId}`
  );
}

/**
 * Promote a location to primary.
 * The backend automatically syncs the top-level address field.
 */
export function setPrimaryLocation(organizationId, locationId) {
  return axios.patch(
    `${URL}organizations/${organizationId}/locations/${locationId}/set-primary`
  );
}

// ================================
// LEGACY SUPPORT
// ================================

/** @deprecated Use getUserOrganizations instead */
export function request_partner() {
  return getUserOrganizations();
}

/** @deprecated Use forgotPassword instead */
export function send_pin_forgot(data) {
  return forgotPassword(data);
}

/** @deprecated */
export function resend_confirmation() {
  return sendVerificationEmail();
}

/** @deprecated */
export function send_pin(data) {
  return verifyEmail(data.token || data.code);
}

export function socialLogin(data) {
  return axios.post(`${URL}auth/social-auth`, data);
}

export function initiateSso(email) {
  return axios.get(`${URL}auth/sso/initiate`, {
    params: {
      email,
      redirect_uri: `${window.location.origin}/auth/sso/callback`,
    },
  });
}

// Export legacy URLs
export const LOGIN_URL = `${URL}auth/login`;
export const REGISTER_URL = `${URL}auth/register`;
export const ME_URL = `${URL}user/profile`;